var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGd = function SvgGd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M5.236 2.087A11.943 11.943 0 0 1 12 0c2.509 0 4.837.77 6.763 2.087L12 2.609l-6.764-.522Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "m12 12-.765-.766-.204.364.97.401Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M3.515 3.515c-4.687 4.686-4.687 12.284 0 16.97L12 12 3.515 3.515ZM20.485 3.516c4.687 4.686 4.687 12.284 0 16.97L12 12.002l8.485-8.485Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M12 16.174a4.174 4.174 0 1 0 0-8.348 4.174 4.174 0 0 0 0 8.348Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m12 7.826.935 2.88h3.028l-2.45 1.78.936 2.88-2.45-1.78-2.449 1.78.936-2.88-2.45-1.78h3.028L12 7.826Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M12.004 0h-.008a11.962 11.962 0 0 0-8.48 3.514h16.969A11.962 11.962 0 0 0 12.005 0ZM3.516 20.486A11.962 11.962 0 0 0 12 24c3.314 0 6.313-1.343 8.485-3.514H3.515Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m12 1.304.195.598h.628l-.508.37.194.597-.508-.37-.509.37.194-.597-.508-.37h.628l.195-.598ZM9.09 1.304l.195.598h.628l-.508.37.194.597-.509-.37-.508.37.194-.597-.508-.37h.628l.194-.598ZM14.91 1.304l.194.598h.629l-.509.37.194.597-.508-.37-.509.37.195-.597-.51-.37h.63l.194-.598ZM12 21.13l.195.598h.628l-.508.37.194.597-.508-.37-.509.37.194-.598-.508-.37h.628l.195-.597ZM9.09 21.13l.195.598h.628l-.508.37.194.597-.509-.37-.508.37.194-.598-.508-.37h.628l.194-.597ZM14.91 21.13l.194.598h.629l-.509.37.194.597-.508-.37-.509.37.195-.598-.51-.37h.63l.194-.597ZM3.657 11.802a1.043 1.043 0 0 1-1.764 1.116c-.558-.881-.234-2.321-.234-2.321s1.44.323 1.998 1.205Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M3.054 13.322a.522.522 0 1 0 0-1.043.522.522 0 0 0 0 1.043Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGd;